import api from "../services/api";

export async function generateApiKey(payload) {
  const { data } = await api.post("/api/api-keys", payload);
  return data;
}

export async function fetchApiKeys() {
  const { data } = await api.get("/api/api-keys");
  return data;
}

export async function updateApiKey(id, payload) {
  const { data } = await api.put(`/api/api-keys/${id}`, payload);
  return data;
}

export async function revokeApiKey(id) {
  const { data } = await api.delete(`/api/api-keys/${id}`);
  return data;
}
